import { TranscodeFragment } from '~/graphqlTypes/TranscodeFragment';

// Define your preferred encodings and bitrates in descending order of preference
const preferredEncodings = ['hls', 'mp3', 'aac'];
const preferredBitrates = [256, 192, 128, 64];

// Utility function to format and sort transcodes
const formatAndSortTranscodes = ( transcodes: TranscodeFragment[] ) => {
  if ( !transcodes || transcodes?.length === 0 ) {
    return [];
  }
  return transcodes
    .map( ( transcode ) => ( {
      ...transcode,
      encodingPriority: transcode.encoding ? preferredEncodings.indexOf( transcode.encoding ) : -1,
      bitratePriority: preferredBitrates.indexOf( transcode.bitrate ?? -1 ),
    } ) )
    .filter( ( transcode ) => 
      transcode.encodingPriority !== -1 && 
      transcode.bitratePriority !== -1 &&
      !( transcode.encoding?.toLowerCase().startsWith( 'quiet' ) ) && // Exclude encodings that start with 'quiet'
      !( transcode.preview ), // Exclude transcodes with a positive preview value
    )
    .sort( ( a, b ) => {
      if ( a.encodingPriority === b.encodingPriority ) {
        return a.bitratePriority - b.bitratePriority;
      }
      return a.encodingPriority - b.encodingPriority;
    } );
};

export const findBestTranscode = ( transcodes: TranscodeFragment[] ): TranscodeFragment | null => {
  if ( !transcodes || transcodes.length === 0 ) {
    return null;
  }
  const sortedTranscodes = formatAndSortTranscodes( transcodes );
  return sortedTranscodes.length > 0 ? sortedTranscodes[0] : null;
};
